
<app-user-header class="d-md-none"></app-user-header> 
<div class="row m-0 h-100 bg-white row-container"> 


  <div class="col-md-2 bg-white p-0 ps-0 section-side-nav h-100 d-none d-md-block">
    <app-sidebar ></app-sidebar>
  </div>
  <div class="col-md-10 big-area p-0">

<div class="wrapperi">

    <div class="col-12 row mt-4">
        <div class="col-1"></div>
        <div class="col-10">
            <h2>Suorahaku</h2>
            <p class="mb-4 pb-2">Tästä voit katsoa etsiä profiileja</p>
            <div class="col-12 row p-0 m-0">
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg1">
                        
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{openings.length}}</h2>
                                <p class="white-text">Profiilia yhteensä</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-1 big-icon fa-user"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4">
                    <div class=" formed-shadow bg2">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">10</h2>
                                <p class="white-text">Uutta profiilia</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-2 big-icon fa-search-plus"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="col-4 p-0">
                    <div class=" formed-shadow bg3">
                        <div class="p-4 row">
                            <div class="col text-start">
                                <h2 class="white-text ">{{open_profiles}}</h2>
                                <p class="white-text">Avattua profiilia</p>
                            </div>
                            <div class="col-3 text-end d-flex justify-content-end">
                                <div class="whiteball mt-3 d-flex align-items-center justify-content-center text-center">
                                    <i class="far icon-3 big-icon fa-lock-open"></i>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-1"></div>
    </div>
  
  
    <div class="col-12 p-0 row m-0">
      <div class="col-1"></div>
      <div class="col-12 col-md-10 p-0 input-cover mt-4">
        <div class="" *ngIf="openings && openings.length > 0">


            <div class="row">
                <div class="col-md-6 mt-3" *ngFor="let opening of openings">
                    <div class="card formed-shadow h-100">
                        <div class="card-body mt-3">
                            <div class="col-12 row">
                                <div class="col-6">
                                    <div class="col-12 text-center justify-content-center">
                                        <div class=" mb-3 ">
                                        <div *ngIf="opening.image;else no_image">
                                            <img src="{{opening.image}}"  alt="">
                                            
                                        </div>
                                        <ng-template #no_image>
                                            <img src="../../assets/images/formed_profile.png" width="100" height="100" alt="">
                                            
                                        </ng-template>
                                    </div>
                                    <h4 class="mb-1"> {{opening.firstName}}</h4>
                                    <p class="mb-0 bold">
                                        <span *ngIf="opening.mdType ">
                                            {{opening.mdType.name_fi}}
                                        </span>
                                        </p>  
                                        <div class="mb-0 "*ngIf="opening.mdSubType" >
                                            <div class="" *ngFor="let data of opening.mdSubType">
                                                <p class="mb-0 xs" >{{data.name_fi}}</p>
                                            </div>
                                        </div>  
                                    <div class="mt-3 text-center d-flex justify-content-center col-12" *ngIf="!opening.can_open">
                                        <button type="button" (click)="openProfile(opening)" class="btn btn-formed-seconday-white">Avaa profiili</button>
                                    </div>
                                    <div class="mt-3 text-center d-flex justify-content-center col-12" *ngIf="opening.can_open">
                                        <button type="button" (click)="routeProfile(opening)" class="btn btn-formed-seconday-white">Näytä profiili</button>
                                    </div>
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="media-body col-12 text-left">
                                        <h4 class="mb-0 bold"> {{opening.experience}}</h4>
                                        <p class="mb-0">kokemusta vuosina</p>
                                        <hr>
                                        <h4 class="mb-0 bold"> {{opening.languages.length}}</h4>
                                        <p class="mb-0">puhutut kielet</p>
                                        <hr>
                                        <p class="mb-0"><i class="fal fa-globe-americas me-2"></i>Äidinkieli: {{opening.main_language}}</p>
    
                                        <p class="mb-4"><i class="fal fa-briefcase me-2"></i>Y-tunnus: 
                                            <span *ngIf="opening.businessNumber;else no_company">
                                                Kyllä
                                            </span>
                                            <ng-template #no_company>
                                                Ei
                                            </ng-template>

                                        </p>
    
                                    </div>
                                </div>

            
                            </div>
                        </div>
                    </div>

                </div>
                </div>
            </div>

        </div>
        <div class="col-1"></div>
  </div>
</div>


    </div>